module.exports = __webpack_public_path__ + "img/754.d9ddb3f4.jpg";